export default __webpack_public_path__ + "media/samples/INSPO_VIDEOS-c4c4c54f.jpg";